import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import * as types from "../../constants/ComponentConstants";
import ValidationMessage from "../common/ValidationMessage";
import nl from 'date-fns/locale/nl';

import DatePicker, { registerLocale } from "react-datepicker";

import "../../../node_modules/react-datepicker/dist/react-datepicker.css";
import "../../../node_modules/react-datepicker/dist/react-datepicker-cssmodules.css";

registerLocale("NL", nl);

const DatePickerVTT = (props) => {
	const hasValidationMessage = !!props.validationMessage;
	const validationMessageType = props.validationMessageType;
	let validation = props.validationMessage ? <ValidationMessage message={props.validationMessage} type={validationMessageType} /> : null;
	const sizeClassName = props.size ? "o-col-" + props.size : "o-col-12";

	const handleOnChange = (e) => {
		let event = {
			target: {
				value: e,
				name: props.name
			}
		};

		props.onChange(event);
	};

	const containerClassName = classnames({
		"c-input": true,
		"error": hasValidationMessage,
		"warning": hasValidationMessage && validationMessageType === types.ValidationMessageTypes.WARNING,
		"disabled": props.disabled,
		"date-picker-z-index" : props.zIndex,
		"relative" : true
	});

	const hasValue = !!props.value;

	return (
		<div className={sizeClassName}>
			<div className={containerClassName}>
				{!hasValue && (
					<span className="c-input__placeholder react-date">
						{props.placeholderText}
					</span>
				)}
				<DatePicker
                    portalId="vtt-react-datepicker-popper"
					className={"c-input__field"}
					popperPlacement="top"
					selected={props.value ? new Date(props.value) : null}
					popperProps={{
						positionFixed: true
					}}
					dateFormat="dd-MM-yyyy"
					minDate={props.minDate}
					onChange={handleOnChange}
					locale="NL"
				/>
			</div>
			{validation}
		</div >
	);
};

DatePickerVTT.propTypes = {
	placeholderText : PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	validationMessage: PropTypes.string,
	validationMessageType: PropTypes.string,
	size: PropTypes.number,
	onChange: PropTypes.func.isRequired,
	value: PropTypes.oneOfType([
		PropTypes.object,
		PropTypes.string
	]),
	disabled: PropTypes.bool,
	id: PropTypes.string.isRequired,
	zIndex: PropTypes.bool,
	minDate: PropTypes.object,
};

export default DatePickerVTT;